"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3092],{

/***/ 327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H8": function() { return /* binding */ SearchDate; },
/* harmony export */   "RC": function() { return /* binding */ convertDisplayDate; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "sL": function() { return /* binding */ getTomorrow; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _assets_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1279);


/**
 * DB検索用日付取得
 */

var SearchDate = function SearchDate() {
  return dayjs__WEBPACK_IMPORTED_MODULE_0___default().tz(dayjs__WEBPACK_IMPORTED_MODULE_0___default()().toDate(), _assets_constants__WEBPACK_IMPORTED_MODULE_1__/* .UTC_TIME_ZONE */ .bN).toDate();
};
/**
 * 明日の日付取得
 */

var getTomorrow = function getTomorrow() {
  return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().add(1, 'day');
};
/**
 * YYYY.MM.DD HH:mmに変換する
 * @param date 日付
 */

var convertDisplayDate = function convertDisplayDate(date) {
  return formatDate(date, 'YYYY.MM.DD HH:mm');
};
/**
 * 表示フォーマット形式の文字列に変換する
 * @param date 日付
 * @param format フォーマット
 */

var formatDate = function formatDate(date, format) {
  return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format(format);
};

/***/ }),

/***/ 3570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ NotificationList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/views/parts/bases/VStack.tsx
var VStack = __webpack_require__(2326);
// EXTERNAL MODULE: ./src/views/parts/bases/HStack.tsx
var HStack = __webpack_require__(1078);
// EXTERNAL MODULE: ./src/views/parts/bases/Text.tsx
var Text = __webpack_require__(1695);
// EXTERNAL MODULE: ./src/views/parts/commons/Paging/Paging.tsx + 2 modules
var Paging = __webpack_require__(4920);
// EXTERNAL MODULE: ./node_modules/@victgame/akiverse-backend/dist/event_message.js
var event_message = __webpack_require__(9761);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 7 modules
var i18next = __webpack_require__(5751);
// EXTERNAL MODULE: ./src/utils/DateUtils.ts
var DateUtils = __webpack_require__(327);
;// CONCATENATED MODULE: ./src/views/parts/commons/NotificationList/constants/index.tsx



var getTitleAndDetails = function getTitleAndDetails(_ref) {
  var messageJson = _ref.messageJson,
      messageDetailJson = _ref.messageDetailJson;
  var notification = event_message/* MessageSchema.parse */.QI.parse(messageJson);

  switch (notification.messageId) {
    case 'A00001':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId))
        };
      }

    case 'A00002':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            // 序数にする
            totalMegaSpark: (0,i18next.t)('ordinal', {
              count: notification.totalMegaSpark,
              ordinal: true
            })
          })
        };
      }

    case 'A00003':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId))
        };
      }

    case 'A00004':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId))
        };
      }

    case 'I00001':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId
          })
        };
      }

    case 'I00002':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId
          })
        };
      }

    case 'I00003':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId
          })
        };
      }

    case 'I00004':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId,
            date: (0,DateUtils/* formatDate */.p6)(notification.stopRentingDate, 'YYYY.MM.DD')
          })
        };
      }

    case 'I00005':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId,
            date: (0,DateUtils/* formatDate */.p6)(notification.stopRentingDate, 'YYYY.MM.DD')
          })
        };
      }

    case 'I00006':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId
          })
        };
      }

    case 'I00008':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            amId: notification.arcadeMachineId
          })
        };
      }

    case 'I00009':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            amId: notification.arcadeMachineId
          })
        };
      }

    case 'I00010':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId,
            amId: notification.arcadeMachineId
          })
        };
      }

    case 'I00011':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId
          })
        };
      }

    case 'I00012':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId,
            amId: notification.arcadeMachineId
          })
        };
      }

    case 'I00013':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId,
            amId: notification.arcadeMachineId
          })
        };
      }

    case 'I00014':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId,
            amId: notification.arcadeMachineId
          })
        };
      }

    case 'I00015':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId,
            amId: notification.arcadeMachineId
          })
        };
      }

    case 'I00016':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId
          })
        };
      }

    case 'I00017':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId
          })
        };
      }

    case 'I00018':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gcId: notification.gameCenterId
          })
        };
      }

    case 'I00019':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            apName: notification.name
          })
        };
      }

    case 'I00020':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            apName: notification.name
          })
        };
      }

    case 'I00021':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            craftId: notification.arcadeMachineId
          })
        };
      }

    case 'I00022':
      {
        var _Information_Detail_P = event_message/* Information_Detail_PaymentRentalFee.parse */.B2.parse(messageDetailJson),
            details = _Information_Detail_P.details;

        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            num: notification.inOperationGcCount.toLocaleString(),
            renewCount: notification.renewCount.toLocaleString(),
            uninstallCount: notification.uninstallCount.toLocaleString()
          }),
          details: details.map(function (d) {
            switch (d.messageId) {
              case 'I00022-success':
                return (0,i18next.t)("Notifications.".concat(d.messageId), {
                  fee: d.fee.toLocaleString(),
                  amId: d.arcadeMachineId
                });

              case 'I00022-fail':
                return (0,i18next.t)("Notifications.".concat(d.messageId), {
                  amId: d.arcadeMachineId
                });

              default:
                {
                  var n = d;
                  return JSON.stringify(n);
                }
            }
          })
        };
      }

    case 'I00023':
      {
        var _Information_Detail_C = event_message/* Information_Detail_CollectRentalFee.parse */.rU.parse(messageDetailJson),
            _details = _Information_Detail_C.details;

        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            num: notification.installedCount.toLocaleString(),
            renewCount: notification.renewCount.toLocaleString(),
            uninstallCount: notification.uninstallCount.toLocaleString()
          }),
          details: _details.map(function (d) {
            switch (d.messageId) {
              case 'I00023-success':
                return (0,i18next.t)("Notifications.".concat(d.messageId), {
                  fee: d.fee.toLocaleString(),
                  amId: d.arcadeMachineId
                });

              case 'I00023-fail':
                return (0,i18next.t)("Notifications.".concat(d.messageId), {
                  amId: d.arcadeMachineId
                });

              default:
                {
                  var n = d;
                  return JSON.stringify(n);
                }
            }
          })
        };
      }

    case 'I00024':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            arcadeMachineId: notification.arcadeMachineId
          })
        };
      }

    case 'I00025':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            arcadeMachineId: notification.arcadeMachineId
          })
        };
      }

    case 'I00026':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gameCenterId: notification.gameCenterId
          })
        };
      }

    case 'I00027':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            arcadeMachineId: notification.arcadeMachineId
          })
        };
      }

    case 'I00028':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            arcadeMachineId: notification.arcadeMachineId
          })
        };
      }

    case 'I00029':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            gameCenterId: notification.gameCenterId
          })
        };
      }

    case 'I00030':
      {
        return {
          title: (0,i18next.t)("Notifications.".concat(notification.messageId), {
            arcadeMachineId: notification.arcadeMachineId
          })
        };
      }

    default:
      var d = notification;
      return {
        title: JSON.stringify(d)
      };
  }
};
// EXTERNAL MODULE: ./src/views/parts/bases/Center.tsx
var Center = __webpack_require__(4582);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./public/images/noData.png
var noData = __webpack_require__(8078);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/views/parts/commons/NotificationList/Layout.tsx













var Layout = function Layout(props) {
  var notifications = props.notifications,
      paging = props.paging;
  var allCount = paging.allCount,
      maxPage = paging.maxPage,
      currentPage = paging.currentPage,
      onClickPage = paging.onClickPage;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
    className: "h-full w-full overflow-hidden rounded-2xl border border-[#805BE7]  bg-black",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
      className: "blue_scroll_bar w-full flex-1 overflow-x-hidden overflow-y-scroll",
      children: notifications.length > 0 ? notifications.map(function (n, index) {
        try {
          var _getTitleAndDetails = getTitleAndDetails(n),
              title = _getTitleAndDetails.title,
              details = _getTitleAndDetails.details;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
            className: "p-5 ".concat(index % 2 === 0 ? 'bg-black' : 'bg-[#1A122E]'),
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
              className: "ml-4 flex-1",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                className: " text-white",
                children: title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
                className: "ml-4",
                children: details === null || details === void 0 ? void 0 : details.map(function (m) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                    className: " text-white",
                    children: m
                  }, m);
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
              className: "text-white",
              children: (0,DateUtils/* convertDisplayDate */.RC)(n.createdAt)
            })]
          }, n.id);
        } catch (e) {
          console.log(e);
          return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
        className: "h-full w-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 140,
          height: 140,
          src: noData/* default */.Z,
          alt: "No Data"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paging/* Paging */.P, {
      allCount: allCount,
      maxPage: maxPage,
      currentPage: currentPage,
      onClickPage: onClickPage
    })]
  });
};
// EXTERNAL MODULE: ./src/views/parts/commons/NotificationList/query.generated.ts
var query_generated = __webpack_require__(3276);
;// CONCATENATED MODULE: ./src/views/parts/commons/NotificationList/useProps.ts


var NOTIFICATION_PAGE_COUNT = 10;
var useProps = function useProps(_ref) {
  var _countData$currentUse, _data$currentUserNoti;

  var nftType = _ref.nftType,
      notificationType = _ref.notificationType;

  var _useState = (0,react.useState)(1),
      currentPage = _useState[0],
      setCurrentPage = _useState[1];

  var _useNotificationsCoun = (0,query_generated/* useNotificationsCountQuery */.nI)({
    variables: {
      where: {
        nftType: {
          "in": nftType
        },
        notificationType: {
          equals: notificationType
        }
      }
    }
  }),
      countData = _useNotificationsCoun.data;

  var _useNotificationsQuer = (0,query_generated/* useNotificationsQuery */.lF)({
    variables: {
      where: {
        nftType: {
          "in": nftType
        },
        notificationType: {
          equals: notificationType
        }
      },
      orderBy: {
        createdAt: query_generated/* SortOrder.Desc */.As.Desc
      },
      skip: (currentPage - 1) * NOTIFICATION_PAGE_COUNT,
      take: NOTIFICATION_PAGE_COUNT
    }
  }),
      data = _useNotificationsQuer.data,
      refetch = _useNotificationsQuer.refetch;

  var allCount = (_countData$currentUse = countData === null || countData === void 0 ? void 0 : countData.currentUserNotificationsCount.count) !== null && _countData$currentUse !== void 0 ? _countData$currentUse : 0;
  var maxPage = Math.ceil(allCount / NOTIFICATION_PAGE_COUNT);
  return {
    notifications: (_data$currentUserNoti = data === null || data === void 0 ? void 0 : data.currentUserNotifications) !== null && _data$currentUserNoti !== void 0 ? _data$currentUserNoti : [],
    paging: {
      allCount: allCount,
      maxPage: maxPage,
      currentPage: currentPage,
      onClickPage: function onClickPage(page) {
        if (page < 0 || page > maxPage) return;
        setCurrentPage(page);
        refetch();
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/views/parts/commons/NotificationList/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var NotificationList = function NotificationList(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout, _objectSpread({}, useProps(props)));
};

/***/ }),

/***/ 4920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ Paging; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/views/parts/bases/HStack.tsx
var HStack = __webpack_require__(1078);
// EXTERNAL MODULE: ./src/views/parts/bases/Text.tsx
var Text = __webpack_require__(1695);
// EXTERNAL MODULE: ./src/views/parts/bases/Clickable.tsx
var Clickable = __webpack_require__(269);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/iconArrowLeft.png
/* harmony default export */ var iconArrowLeft = ({"src":"/_next/static/media/iconArrowLeft.da97c4cb.png","height":48,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEVMaXH////////////////////7e1ULAAAABnRSTlMAid5ejR4G28MHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAHklEQVQImWNgQAaMzBCahYkVwmeCScAYcCmEYjAAAAVGACWkV7CxAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconArrowRight.png
/* harmony default export */ var iconArrowRight = ({"src":"/_next/static/media/iconArrowRight.605d206b.png","height":48,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEVMaXH////////////////////7e1ULAAAABnRSTlMAid6NXh4jAd6yAAAACXBIWXMAACE4AAAhOAFFljFgAAAAHklEQVQImWNgQAAWRiiDlYkZJsYEE4My4FJwxRAAAAVuACX0DyqJAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/views/parts/bases/Center.tsx
var Center = __webpack_require__(4582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/views/parts/commons/Paging/Paging.tsx












var Paging = function Paging(props) {
  var Pagination = function Pagination() {
    var currentPage = props.currentPage,
        maxPage = props.maxPage,
        onClickPage = props.onClickPage;
    var displayPages = [];
    var items = [];

    for (var i = 1; i <= maxPage; i++) {
      if (i == 1 || i == maxPage || currentPage < 5 && i <= 7 || maxPage - currentPage < 5 && i > maxPage - 7 || i >= currentPage - 2 && i <= currentPage + 2) {
        displayPages.push(i);
      }
    }

    var previousPage = 0;

    var _loop = function _loop() {
      var page = _displayPages[_i];

      if (previousPage) {
        if (page - previousPage === 2) {
          items.push( /*#__PURE__*/(0,jsx_runtime.jsx)(PageIcon, {
            onClick: function onClick() {
              return onClickPage(previousPage + 1);
            },
            selected: previousPage + 1 === currentPage,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
              className: "text-base font-semibold text-white",
              children: previousPage + 1
            })
          }, "page_".concat(previousPage + 1)));
        } else if (page - previousPage > 2) {
          items.push( /*#__PURE__*/(0,jsx_runtime.jsx)(Ellipsis, {}, "page_".concat(previousPage + 1)));
        }
      }

      items.push( /*#__PURE__*/(0,jsx_runtime.jsx)(PageIcon, {
        onClick: function onClick() {
          return onClickPage(page);
        },
        selected: page === currentPage,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          className: "text-base font-semibold text-white",
          children: page
        })
      }, "page_".concat(page)));
      previousPage = page;
    };

    for (var _i = 0, _displayPages = displayPages; _i < _displayPages.length; _i++) {
      _loop();
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: items.map(function (e) {
        return e;
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
    className: "flex-wrap justify-center gap-2 py-3",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageIcon, {
      onClick: function onClick() {
        return props.currentPage !== 1 && props.onClickPage(props.currentPage - 1);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: iconArrowLeft,
        height: 32,
        width: 32,
        alt: "left"
      })
    }), props.maxPage <= 9 ? (0,toConsumableArray/* default */.Z)(Array(props.maxPage ? props.maxPage : 1)).map(function (_, i) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PageIcon, {
        onClick: function onClick() {
          return props.onClickPage(i + 1);
        },
        selected: i + 1 === props.currentPage,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          className: "font-semibold text-white ".concat(String(i + 1).length >= 3 ? 'text-sm' : 'text-base'),
          children: i + 1
        })
      }, "page_".concat(i + 1));
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Pagination, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(PageIcon, {
      onClick: function onClick() {
        return props.currentPage !== props.maxPage && props.onClickPage(props.currentPage + 1);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: iconArrowRight,
        height: 32,
        width: 32,
        alt: "right"
      })
    })]
  });
};

var PageIcon = function PageIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Clickable/* Clickable */.P, {
    className: "h-8 w-8 items-center justify-center rounded-md p-1.5 ".concat(props.selected ? 'bg-akiverse-pink' : 'border border-white/40'),
    onClick: props.onClick,
    children: props.children
  });
};

var Ellipsis = function Ellipsis() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
    className: "h-8 w-8 items-center justify-center rounded-md p-1.5",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
      className: "text-base font-semibold text-white/40",
      children: "..."
    })
  });
};

/***/ }),

/***/ 4033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ HistoricalPerformance; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/views/parts/bases/Absolute.tsx
var Absolute = __webpack_require__(3975);
// EXTERNAL MODULE: ./src/views/parts/bases/Center.tsx
var Center = __webpack_require__(4582);
// EXTERNAL MODULE: ./src/views/parts/bases/Clickable.tsx
var Clickable = __webpack_require__(269);
// EXTERNAL MODULE: ./src/views/parts/bases/HStack.tsx
var HStack = __webpack_require__(1078);
// EXTERNAL MODULE: ./src/views/parts/bases/Space.tsx
var Space = __webpack_require__(2952);
// EXTERNAL MODULE: ./src/views/parts/bases/Text.tsx
var Text = __webpack_require__(1695);
// EXTERNAL MODULE: ./src/views/parts/bases/VStack.tsx
var VStack = __webpack_require__(2326);
;// CONCATENATED MODULE: ./public/images/iconGraphPrev.png
/* harmony default export */ var iconGraphPrev = ({"src":"/_next/static/media/iconGraphPrev.84f28a20.png","height":32,"width":32,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEUI+uIA++sA++sA++sA++sB+uoA++sA++xqtM4xAAAACHRSTlMB862lPTZ5eLEa4kIAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAhSURBVAiZY2BABszsEJqJkQXCZ2SFSsAYcCkGBiY2JK0AB2EAM8ffqrYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconGraphNext.png
/* harmony default export */ var iconGraphNext = ({"src":"/_next/static/media/iconGraphNext.ae3ec5e4.png","height":32,"width":32,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEUI++cA++wA++sB+uoB+usA++sA++wA++stLJqpAAAACHRSTlMB86U2Pax4rzrHdv8AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAhSURBVAiZY2BAADZWKIOFkR3KYmZkQmWwMEIVsUEloAAACDMANkovQHUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(2120);
// EXTERNAL MODULE: ./public/images/noData.png
var noData = __webpack_require__(8078);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/views/parts/gc/HistoricalPerformance.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var HistoricalPerformance = function HistoricalPerformance(props) {
  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
    className: "min-h-[400px] w-full flex-[3] rounded-xl border border-[#805BE7] bg-black p-5 pb-8",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
      className: "text-xl font-bold text-white",
      children: t('InstallationStatus.performanceAreaTitle')
    }), props.visibleNodata ? /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
      className: "h-full w-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        width: 140,
        height: 140,
        src: noData/* default */.Z,
        alt: "No Data"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
        className: "mt-4",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(HistoricalPerformanceTargetSwitcher, _objectSpread({}, props))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Graph, {
        data: props.chartValus
      })]
    })]
  });
};

var HistoricalPerformanceTargetSwitcher = function HistoricalPerformanceTargetSwitcher(props) {
  var _useTranslation2 = (0,es/* useTranslation */.$G)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HistoricalPerformanceTargetSwitcherButton, {
      active: props.target === 'AwardsReceived',
      onClick: function onClick() {
        return props.onSelected('AwardsReceived');
      },
      children: t('HistoricalPerformance.awardsReceivedTab')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HistoricalPerformanceTargetSwitcherButton, {
      active: props.target === 'Earnings',
      onClick: function onClick() {
        return props.onSelected('Earnings');
      },
      children: t('HistoricalPerformance.earnings')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HistoricalPerformanceTargetSwitcherButton, {
      active: props.target === 'Contractors',
      onClick: function onClick() {
        return props.onSelected('Contractors');
      },
      children: t('HistoricalPerformance.contractors')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HistoricalPerformanceTargetSwitcherButton, {
      active: props.target === 'Sparks',
      onClick: function onClick() {
        return props.onSelected('Sparks');
      },
      children: t('HistoricalPerformance.sparksTab')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HistoricalPerformanceTargetSwitcherButton, {
      active: props.target === 'AvarageOccupancyRateOfAmSlots',
      onClick: function onClick() {
        return props.onSelected('AvarageOccupancyRateOfAmSlots');
      },
      children: t('HistoricalPerformance.avarageOccupancyRateOfAmSlots')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HistoricalPerformanceTargetSwitcherButton, {
      active: props.target === 'PlayersInMyGcs',
      onClick: function onClick() {
        return props.onSelected('PlayersInMyGcs');
      },
      children: t('HistoricalPerformance.playersInMyGcs')
    })]
  });
};

var HistoricalPerformanceTargetSwitcherButton = function HistoricalPerformanceTargetSwitcherButton(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Clickable/* Clickable */.P, {
    onClick: props.onClick,
    className: "m-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
      className: "h-8 rounded-full border\n        ".concat(props.active ? 'border-akiverse-pink' : 'border-neutral-700', "\n        ").concat(props.active ? 'bg-akiverse-pink' : 'bg-transparent', "\n        bg-opacity-50 px-4"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
        className: "text-xs font-bold\n        ".concat(props.active ? 'text-white' : 'text-neutral-700'),
        children: props.children
      })
    })
  });
};

var Graph = function Graph(props) {
  var _sorted$0$unixTimeSta, _sorted$, _sorted;

  var yAxisCounts = 11;
  var sorted = props.data.sort(function (a, b) {
    return a.unixTimeStamp > b.unixTimeStamp ? 1 : -1;
  });
  var startUnixTimestamp = (_sorted$0$unixTimeSta = (_sorted$ = sorted[0]) === null || _sorted$ === void 0 ? void 0 : _sorted$.unixTimeStamp) !== null && _sorted$0$unixTimeSta !== void 0 ? _sorted$0$unixTimeSta : dayjs_min_default()().unix();
  var endUnixTimestamp = (_sorted = sorted[sorted.length - 1]) === null || _sorted === void 0 ? void 0 : _sorted.unixTimeStamp;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
    className: "relative h-full w-full",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
      className: "my-7 w-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* Text */.x, {
        className: "text-lg font-bold text-neon-blue",
        children: ["season \u03B21 ", dayjs_min_default().unix(startUnixTimestamp).format('YYYY.MM.DD'), "~", endUnixTimestamp ? dayjs_min_default().unix(endUnixTimestamp).format('MM.DD') : '']
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
      className: "h-full w-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
        className: "mr-8 h-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          objectFit: "contain",
          src: iconGraphPrev,
          alt: "Prev"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(YLabels, {
        values: props.data.map(function (d) {
          return d.value;
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
        className: "h-full flex-1 py-2",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
          className: "h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Absolute/* Absolute */.e, {
            className: "top-0 left-0 bottom-0 right-0 h-full w-full",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(YAxis, {
              count: yAxisCounts
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Absolute/* Absolute */.e, {
            className: "top-0 left-0 bottom-0 right-0 h-full w-full",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(BarCharts, {
              values: props.data
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Absolute/* Absolute */.e, {
          className: "bottom-[-20px] left-0 right-0 w-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(HStack/* HStack */.U, {
            className: "w-full",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(XLabels, {
              unixTimeStamps: props.data.map(function (d) {
                return d.unixTimeStamp;
              })
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
        className: "ml-8 h-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          objectFit: "contain",
          src: iconGraphNext,
          alt: "Next"
        })
      })]
    })]
  });
};

var YLabels = function YLabels(props) {
  var range = getValuesRange(props.values);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
    className: "h-full items-end pr-2",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
      className: "text-xs text-neon-blue",
      children: range.max
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Space/* Space */.T, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
      className: "text-xs text-neon-blue",
      children: (range.max - range.min) / 2
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Space/* Space */.T, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
      className: "text-xs text-neon-blue",
      children: range.min
    })]
  });
};

var YAxis = function YAxis(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
    className: "h-full w-full",
    children: [Array(props.count - 1).fill('').map(function (_, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "h-px w-full bg-gray-600"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Space/* Space */.T, {})]
      }, index);
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-px w-full bg-gray-600"
    })]
  });
};

var XLabels = function XLabels(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
    className: "w-full",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Space/* Space */.T, {}), props.unixTimeStamps.map(function (s) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
          className: "w-7",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
            className: "text-xs text-gray-500",
            children: dayjs_min_default().unix(s).format('DD')
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Space/* Space */.T, {})]
      });
    })]
  });
};

var getValuesRange = function getValuesRange(values) {
  return {
    max: Math.floor(Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(values))),
    min: Math.floor(Math.max(Math.min.apply(Math, (0,toConsumableArray/* default */.Z)(values)) - 10, 0)) // 最小値でも棒グラフが表示されるように最小値から10低い数値を最小値として返している

  };
};

var BarCharts = function BarCharts(props) {
  var range = getValuesRange(props.values.map(function (v) {
    return v.value;
  }));

  var getHeightPercentage = function getHeightPercentage(value) {
    return "".concat(100 * (value - range.min) / (range.max - range.min), "%");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
    className: "h-full w-full items-end",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Space/* Space */.T, {}), props.values.map(function (v, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Bar, {
          height: getHeightPercentage(v.value)
        }, index), /*#__PURE__*/(0,jsx_runtime.jsx)(Space/* Space */.T, {})]
      });
    })]
  });
};

var Bar = function Bar(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "flex w-5 rounded-md bg-[#805BE7] transition-all hover:bg-akiverse-pink",
    style: {
      height: props.height
    }
  });
};

/***/ }),

/***/ 1357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ UserIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/views/parts/bases/Center.tsx
var Center = __webpack_require__(4582);
// EXTERNAL MODULE: ./src/views/parts/bases/Absolute.tsx
var Absolute = __webpack_require__(3975);
// EXTERNAL MODULE: ./src/views/parts/bases/Clickable.tsx
var Clickable = __webpack_require__(269);
;// CONCATENATED MODULE: ./public/images/iconChange.png
/* harmony default export */ var iconChange = ({"src":"/_next/static/media/iconChange.b7363b2a.png","height":96,"width":96,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEUA++wA++wA++wA++xMaXEA++wA+uwA++wA++wA+uyfWWcmAAAACnRSTlN9QLFdAKQ5aQkL/0lXGgAAAAlwSFlzAAAhOAAAITgBRZYxYAAAADNJREFUCJk1yzkOACAQw0Anm+X4/4cRQnQuxiQCJQQzTZDTvS2oMYoC6iXy6o518eTivx8YqACu6v1mLgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/views/parts/icons/UserIcon/Layout.tsx








var Layout = function Layout(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Center/* Center */.M, {
    className: "relative h-40 w-40",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Center/* Center */.M, {
      className: "relative h-40 w-40",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Absolute/* Absolute */.e, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
          className: "overflow-hidden rounded-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            width: 145,
            height: 145,
            objectFit: "contain",
            alt: "user icon",
            src: props.userIconUrl
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        width: 160,
        height: 160,
        objectFit: "contain",
        alt: "user frame",
        src: props.userFrameUrl
      })]
    }), props.onClickEditIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(Absolute/* Absolute */.e, {
      className: "right-0.5 bottom-6 rounded-full bg-black",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Clickable/* Clickable */.P, {
        onClick: props.onClickEditIcon,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: iconChange,
          objectFit: "contain",
          width: 32,
          height: 32,
          alt: "Edit Icon"
        })
      })
    })]
  });
};
// EXTERNAL MODULE: ./src/views/states/LoginUser/index.tsx + 1 modules
var LoginUser = __webpack_require__(8655);
;// CONCATENATED MODULE: ./src/views/parts/icons/UserIcon/useProps.ts

var useProps = function useProps(_ref) {
  var onClickEditIcon = _ref.onClickEditIcon;
  var loginUser = (0,LoginUser/* useLoginUser */.x)().loginUser;
  return {
    userIconUrl: (loginUser === null || loginUser === void 0 ? void 0 : loginUser.userIconUrl) || '',
    userFrameUrl: (loginUser === null || loginUser === void 0 ? void 0 : loginUser.userFrameUrl) || '',
    onClickEditIcon: onClickEditIcon
  };
};
;// CONCATENATED MODULE: ./src/views/parts/icons/UserIcon/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var UserIcon = function UserIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout, _objectSpread({}, useProps(props)));
};

/***/ }),

/***/ 1859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ InstallationStatus; }
/* harmony export */ });
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2120);
/* harmony import */ var _bases_Center__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4582);
/* harmony import */ var _bases_HStack__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1078);
/* harmony import */ var _bases_Space__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2952);
/* harmony import */ var _bases_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1695);
/* harmony import */ var _bases_VStack__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2326);
/* harmony import */ var _public_images_noData_png__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8078);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5893);











var InstallationStatus = function InstallationStatus(props) {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_bases_VStack__WEBPACK_IMPORTED_MODULE_7__/* .VStack */ .g, {
    className: "min-h-[400px] w-full rounded-xl border border-[#805BE7] bg-black p-5",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_bases_Text__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
      className: "text-lg font-bold text-white",
      children: t('InstallationStatus.statusAreaTitle')
    }), props.visibleNoData ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_bases_Center__WEBPACK_IMPORTED_MODULE_3__/* .Center */ .M, {
      className: "h-full w-full",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
        width: 140,
        height: 140,
        src: _public_images_noData_png__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
        alt: "No Data"
      })
    }) : props.datas.map(function (data) {
      var showValue = data.value || data.value === 0;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_bases_HStack__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .U, {
        className: "items-center px-3 py-2",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_bases_Text__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
          className: "text-lg ".concat(showValue ? 'text-white' : 'text-gray-600'),
          children: t("InstallationStatus.".concat(data.titleKey))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_bases_Space__WEBPACK_IMPORTED_MODULE_5__/* .Space */ .T, {}), showValue ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_bases_Text__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
          className: "text-xl font-bold text-neon-blue",
          children: [data.isComma ? (data.value || 0).toLocaleString() : data.value, data.suffix]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(NoValue, {})]
      }, data.titleKey);
    })]
  });
};

var NoValue = function NoValue() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_bases_Text__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
    className: "text-lg font-bold text-gray-700",
    children: "-"
  });
};

/***/ }),

/***/ 9737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/iconComingsoon.aacdc63c.png","height":540,"width":540,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAP1BMVEVAQEBiYmJRUVFhYWFsbGxzc3MxMTFiYmJ7e3txcXFnZ2d7e3t0dHRvb29ZWVk/Pz9eXl5fX1+NjY1xcXGBgYEGPFs5AAAAE3RSTlMB3y9qsOAX+v1lIaI6xLKykUL+h0w2WAAAAAlwSFlzAAAhOAAAITgBRZYxYAAAAD5JREFUCJkVy0sSgCAMwNAghZafaPH+Z3W6zbwAzAzQRjG7gPWZeYviRaQ06G+WW7UCj6ajoeo2PylG+hzrBzbIAabcTM86AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 8078:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/noData.3590f737.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAATlBMVEVMaXF3d3diYmJ/f39oaGhUVFRcXFxmZmZAQEBtbW1eXl5tbW1WVlZ6enp8fHxBQUGEhIR+fn5vb29xcXGIiIiLi4uEhIRfX193d3dubm74x61/AAAAFnRSTlMAjAzGsCfM7Rl2pF18pWSn1+8vVO3+QmBUsAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAD9JREFUCJkVy8cNwDAMALFzlZzeJCf7Lxr4S4CA3g2gpce8AMnMbR7ix5plAy1Lrl0iMHV5RQHdT/vqiMQrhB9RLgIx1q5qAgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 2815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/tofuNFTLogo.ee4b38ba.png","height":300,"width":324,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAJ1BMVEX///////////////////9MaXH///////////////////////////+m09sOAAAADXRSTlOgYbqNSgCBlRJ8sCpALCLVOgAAAAlwSFlzAAAhOAAAITgBRZYxYAAAADNJREFUCJkdwYkRgDAMAzA7NvnK/vNyVIIWKkbhpFwMw+Lm4HpHEdicRB+B3UUz8PzM/QAfHgECR99b+gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});

/***/ })

}]);